import { Button, Table } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPencilPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { SearchField } from '../../components/SearchField';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { whiteIconButtonStyle } from '../../theme/styling/buttonStyling';
import { defaultIconStyle } from '../../theme/styling/iconStyling';
import { queryWithFilterPageAndSearch } from '../../util/api/queryWithFilterPageAndSearch';
import { NewPromotionModal } from './components/NewPromotionModal';
import { PromotionRow } from './components/PromotionRow';
import type { PromotionDto } from './types/PromotionDto';
import { KeyedRow } from '../../components/KeyedRow';

export function Promotions() {
	const { organisation } = useParams();
	const pagination = usePagination();
	const filter = useFilter();
	const [searchQuery, setSearchQuery] = useState('');

	const promotionsCountQuery = queryWithFilterPageAndSearch<number>(
		`${organisation}/promotions/count`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	const promotionsQuery = queryWithFilterPageAndSearch<PromotionDto[]>(
		`${organisation}/promotions/all`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	const [showModal, { open, close }] = useDisclosure(false);

	return (
		<>
			<NewPromotionModal
				isOpened={showModal}
				close={close}
				triggerListUpdate={() => {
					promotionsQuery.remove();
					promotionsCountQuery.remove();

					promotionsQuery.refetch();
					promotionsCountQuery.refetch();
				}}
			/>
			<PageHeader
				title={'Promotions'}
				filter={filter}
				rightContent={
					<Button {...whiteIconButtonStyle} onClick={() => open()}>
						<IconPencilPlus {...defaultIconStyle} />
					</Button>
				}
			>
				<SearchField
					placeholder={'Search descriptions...'}
					onDelayComplete={(value) => setSearchQuery(value)}
					width="20vw"
				/>
			</PageHeader>
			<DataTable
				pagination={pagination}
				totalItems={promotionsCountQuery.data?.value}
				isRowsLoading={promotionsQuery.isLoading}
				isPaginationLoading={promotionsCountQuery.isLoading}
				rows={pagination.value.pageSize}
				minHeight={'67vh'}
				maxHeight={'76vh'}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th><Title label={'Branch'} /></Table.Th>
						<Table.Th><Title label={'Till'} /></Table.Th>
						<Table.Th><Title label={'Description'} /></Table.Th>
						<Table.Th><Title label={'Quantity'} /></Table.Th>
						<Table.Th><Title label={'Discount'} /></Table.Th>
						<Table.Th><Title label={'Type'} /></Table.Th>
						<Table.Th><Title label={'Start Date'} /></Table.Th>
						<Table.Th><Title label={'Start Time'} /></Table.Th>
						<Table.Th><Title label={'End Date'} /></Table.Th>
						<Table.Th><Title label={'End Time'} /></Table.Th>
						<Table.Th><Title label={'View'} /></Table.Th>
						<Table.Th />
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{promotionsQuery.data?.value.map((promotion: PromotionDto) => (
						<PromotionRow
							originalPromotion={promotion}
							triggerListUpdate={() => {
								promotionsQuery.remove();
								promotionsCountQuery.remove();
								
								promotionsQuery.refetch();
								promotionsCountQuery.refetch();
							}}
						/>
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
